import { useState } from "react";

import type { Meta, StoryObj } from "@storybook/react";

import DateTimePicker from "@/ui/composed/pickers/DateTimePicker";
import type { DateTimePickerProps } from "@/ui/composed/pickers/DateTimePicker";

const StoryMeta: Meta<DateTimePickerProps> = {
  title: "Core/Date Time Picker",
  component: DateTimePicker,
  argTypes: {
    isCurrentDateMaxDate: { control: "boolean" },
    isDisabled: { control: "boolean" },
    mode: { control: "radio", options: ["date", "time", "datetime"] },
    testID: { control: "text" },
  },
  args: {
    date: new Date(),
    isDisabled: false,
    mode: "date",
    testID: "date-time-picker-test-id",
  },
  // eslint-disable-next-line no-restricted-syntax -- non-arrow function used here as React FC needed for use of state hook
  render: function Render(args) {
    const [date, setDate] = useState<Date | undefined>(args.date);
    return (
      <DateTimePicker
        {...args}
        date={date}
        onChange={(newDate) => {
          setDate(newDate);
          console.log(`New date picked: ${newDate}`);
        }}
      />
    );
  },
};

type Story = StoryObj<DateTimePickerProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
